import { AfterViewInit, Component, ElementRef, OnChanges, SimpleChanges, input, viewChild } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { NgStyle } from '@angular/common';
import { BaseChartDirective } from 'ng2-charts';
import { DurationGaugePipe } from '../../../mnt/common/pipes/duration-gauge/duration-gauge';
import { Chart, ChartOptions } from 'chart.js';
import 'chart.js/auto';

export interface GaugeBarData {
  color: string;
  name: string;
  minutes: number;
}

@Component({
  selector: 'gauge-bar',
  templateUrl: 'gauge-bar.component.html',
  standalone: true,
  styleUrls: ['./gauge-bar.component.scss'],
  imports: [IonicModule, TranslateModule, NgStyle, DurationGaugePipe, BaseChartDirective],
})
// TODO: see if we can use an effect instead of OnChanges and AfterViewInit
export class GaugeBarComponent implements AfterViewInit, OnChanges {
  gaugeData = input<GaugeBarData[]>([]);
  canvas = viewChild<ElementRef | null>('myChart');
  context: CanvasRenderingContext2D;

  myChart: Chart<'doughnut', number[], unknown> | null = null;

  gaugeChartOptions: ChartOptions<'doughnut'> = {
    cutout: '70%',
    circumference: 360,
    rotation: 270,
    plugins: {
      tooltip: {
        enabled: false,
      },
    },
    events: [], //disable all events (click, mouse hover, etc ...)
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['gaugeData'] && changes['gaugeData'].currentValue) {
      this.updateGauge(changes['gaugeData'].currentValue);
    }
  }

  updateGauge(gaugeData: GaugeBarData[]) {
    if (this.context) {
      if (this.myChart) {
        this.myChart.destroy();
      }

      this.myChart = new Chart(this.context, {
        options: this.gaugeChartOptions,
        type: 'doughnut',
        data: {
          datasets: [
            {
              data: gaugeData.map((d) => d.minutes),
              backgroundColor: gaugeData.map((d) => d.color),
            },
          ],
        },
      });
    }
  }

  ngAfterViewInit(): void {
    if (this.canvas() === null) return;

    this.context = this.canvas().nativeElement.getContext('2d');
    if (this.gaugeData()) {
      this.updateGauge(this.gaugeData()!);
    }
  }
}
